import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnterLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33333 0C5.70153 0 6 0.29848 6 0.666667C6 1.00855 5.74265 1.29034 5.41108 1.32885L5.33333 1.33333H2C1.65811 1.33333 1.37633 1.5907 1.33782 1.92225L1.33333 2V10C1.33333 10.3419 1.5907 10.6237 1.92225 10.6622L2 10.6667H5C5.3682 10.6667 5.66667 10.9651 5.66667 11.3333C5.66667 11.6752 5.40932 11.957 5.07775 11.9955L5 12H2C0.934882 12 0.0642262 11.1674 0.00339508 10.1175L0 10V2C0 0.934882 0.832616 0.0642262 1.88248 0.00339508L2 0H5.33333ZM6.86187 3.64298C7.12227 3.38263 7.54433 3.38263 7.80467 3.64298C8.04504 3.8833 8.06353 4.26146 7.86014 4.52298L7.80467 4.58579L7.05713 5.33333H10.6667C11.0349 5.33333 11.3333 5.6318 11.3333 6C11.3333 6.3419 11.076 6.62367 10.7444 6.66218L10.6667 6.66667H7.05713L7.80467 7.4142C8.06507 7.67453 8.06507 8.09667 7.80467 8.357C7.56436 8.59737 7.18624 8.61586 6.92468 8.41247L6.86187 8.357L4.97627 6.4714C4.73596 6.23109 4.71747 5.85292 4.92081 5.5914L4.97627 5.5286L6.86187 3.64298Z",
		fill: "currentColor"
	})
});
export default SvgEnterLine;
